@if (workouts.list.length > 0) {
  <cs-tab [(selection)]="selectedWorkout" (selectionChange)="onTabChange($event)" fill>
    @for (w of workouts.list; track w.letter) {
      <cs-tab-button [value]="w.letter">{{ w.letter }}</cs-tab-button>
    }
  </cs-tab>
}

@if (workouts.list.length > 0) {
  <cs-tab-content-container [selection]="selectedWorkout"
    [swipeEnabled]="hasClientSmallScreen()" (swipeForward)="handleSwipeForward()" (swipeBack)="handleSwipeBack()">
    @for (w of workouts.list; track w.letter) {
      <cs-tab-content [value]="w.letter">
        <div class="workout-content-box">
          <div class="workout-title">{{ LL.training.trainingProgram.workoutLetter({letter: w.letter}) }}</div>
          <div class="exercise-list">
            @for (e of w.exercises; track e.name; let i = $index) {
              <div class="exercise-item">
                <div class="exercise-badge">{{ i + 1 }}</div>
                <div class="exercise-info">
                  <div class="exercise-name">{{ e.name }}</div>
                  <div class="exercise-details">
                    {{ e.sets }} {{ e.sets === 1 ? LL.training.trainingProgram.set() : LL.training.trainingProgram.sets() }}
                    @if (e.useMyoReps) {
                      | {{ LL.training.trainingProgram.myoReps() }}
                    }
                    @if (e.rmTesting) {
                      | {{ LL.training.trainingProgram.rmTesting() }}
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </cs-tab-content>
    }
  </cs-tab-content-container>
}
